import { useMutation } from '@tanstack/react-query';

import { ChangeActiveStayPricingPlanFormSchemaValues } from 'src/features/stay/utils/formSchema';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/visitors/active-stay/:stayId/change-pricing-plan/';

interface DTO extends ChangeActiveStayPricingPlanFormSchemaValues {
    parkingId: string;
    stayId: string;
}

const mutationFn = ({ parkingId, stayId, ...data }: DTO): Promise<void> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, stayId }), data);
};

type MutationFnType = typeof mutationFn;

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useChangePricingPlan };
